module.exports = __webpack_public_path__ + "static/media/slab.65a5940b.svg";